<div class="stat">
  <div class="row">
    <div class="kpi">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
           stroke-linejoin="round">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M3 5v6c0 1.7 4 3 9 3s9-1.3 9-3V5"/>
        <path d="M3 11v6c0 1.7 4 3 9 3s9-1.3 9-3v-6"/>
      </svg>
      <div>
        <div class="value">{{ value }}</div>
        <div class="label">{{ title }}</div>
      </div>
    </div>
  </div>
  <div class="progress"><span [style.width.%]="progressPercent"></span></div>
</div>
